import { render, staticRenderFns } from "./DashboardAlmacen.vue?vue&type=template&id=aa7a8572&scoped=true"
import script from "./DashboardAlmacen.js?vue&type=script&lang=js&external"
export * from "./DashboardAlmacen.js?vue&type=script&lang=js&external"
import style0 from "./DashboardAlmacen.css?vue&type=style&index=0&id=aa7a8572&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa7a8572",
  null
  
)

export default component.exports